import { Component, OnInit, Input, ViewEncapsulation, HostBinding, HostListener, Output, EventEmitter } from '@angular/core';

import { ContainerComponent } from '../container/container.component';
import { DraggableDirective } from '../../directives/ngx-draggable.directive';
import { BuilderHelper } from '../../../shared/BuilderHelper';
import { BuilderService } from '../../services/builder.service';

/**
 * Component that allows nested ngxDroppable and ngxDraggables
 * Should only be use inside a ngx-dnd-container
 * Outside a ngx-dnd-container use ngxDroppable
 */
@Component({
  selector: 'ngx-dnd-item',
  templateUrl: './item.component.html',
  styleUrls: ['./item.component.scss', '../container/container.component.scss', '../../../fb/components/FormTab/form-tab.component.css'],
  encapsulation: ViewEncapsulation.None,
})
export class ItemComponent implements OnInit {

  @Input()
  get dropZone() {
    return this._dropZone || this.container.dropZone;
  }
  set dropZone(val) {
    this._dropZone = val;
  }

  @Input()
  get dropZones() {
    return this._dropZones || this.container.dropZones;
  }
  set dropZones(val) {
    this._dropZones = val;
  }

  @Input()
  get droppableItemClass() {
    return this._droppableItemClass || this.container.droppableItemClass;
  }
  set droppableItemClass(val) {
    this._droppableItemClass = val;
  }

  @Input()
  get removeOnSpill() {
    return typeof this._removeOnSpill === 'boolean' ? this._removeOnSpill : this.container.removeOnSpill;
  }
  set removeOnSpill(val) {
    this._removeOnSpill = val;
  }

  @Input()
  get copy() {
    return typeof this._copy === 'boolean' ? this._copy : this.container.copy;
  }
  set copy(val) {
    this._copy = val;
  }

  get hasHandle(): boolean {
    return this.draggableDirective.hasHandle;
  }

  get moveDisabled(): boolean {
    return !this.draggableDirective.canMove();
  }

  get rowData() {
    if (!this.model || !this.model.template || !(Array.isArray(this.model.template) || this.model.template.cells)) {
      return;
    }
    return (this.model.template.cells || this.model.template)
      .map(cell => cell.name)
      .filter(text => text && text.trim())
      .join('|');
  }

  @HostBinding('class')
  get classString() {
    const itemClass = typeof this.droppableItemClass === 'function' ? this.droppableItemClass(this.model) : this.droppableItemClass;

    const classes = ['ngx-dnd-item', itemClass || ''];
    if (this.moveDisabled) {
      classes.push('move-disabled');
    }
    if (this.hasHandle) {
      classes.push('has-handle');
    }
    return classes.join(' ');
  }

  get type() {
    if (Array.isArray(this.model)) {
      return 'array';
    }
    return typeof this.model;
  }

  get isRow() {
    return this.model && this.model.template && this.model.template.hasOwnProperty('cells');
  }

  get isTab() {
    return this.model && this.model.template && this.model.template.hasOwnProperty('sections');
  }

  get isSection() {
    return this.model && this.model.template && this.model.template.hasOwnProperty('rows');
  }

  constructor(public container: ContainerComponent, public draggableDirective: DraggableDirective, public builderService: BuilderService) {}
  @Input() disabled: boolean;
  @Input() modelIndex: any;
  @Input() model: any;
  @Input() modelContainer: any;
  @Input() isTemplate: boolean;
  @Input() activeModel;

  _copy = false;
  _dropZone: any;
  _dropZones: any;
  _droppableItemClass: any;
  _removeOnSpill = false;
  data: any;

  @Output('onTemplateDeleted') templateDeleteEvent = new EventEmitter<any>();
  @Output('onTemplateAdded') templateAddEvent = new EventEmitter<any>();

  @HostListener('click')
  onClick() {
    this.builderService.setFocus(this.model);
  }

  isHidden() {
    return BuilderHelper.isHidden(this.model, false, true, !this.disabled);
  }

  deleteTemplate() {
    this.templateDeleteEvent.emit(this.model);
  }

  onTemplateAdded(template) {
    if (!template) {
      return;
    }
    this.templateAddEvent.emit(template);
  }

  ngOnInit() {
    this.data = {
      model: this.model,
      type: this.type,
      dropZone: this.dropZone,
      template: this.container.template,
    };
  }
}
